export default __webpack_public_path__ + "static/media/apari-logo.37d93b0f.svg";